'use strict';

/* Controllers */

app.controller('LogoutController', ['$location', 'Auth', '$rootScope',
    function ($location, Auth, $rootScope) {

        var flow = $rootScope.globals.flow;

        // logout
        Auth.clearCredentials();

        if( flow == 'ticketing' ){
	        $location.path('/event');
        }else{
	        $location.path('/');
        }

    }]);